"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var GenericInputStyles_1 = require("../../../../common/components/genericInput/GenericInputStyles");
var core_1 = require("@material-ui/core");
var TextareaAutosizeInputStyles_1 = require("./TextareaAutosizeInputStyles");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var usePlatformConfig_1 = require("../../../../../common/react/usePlatformConfig");
var TextareaAutosizeInput = function (_a) {
    var formData = _a.formData;
    var label = formData.label, required = formData.required, id = formData.id, onChange = formData.onChange, value = formData.value, rawErrors = formData.rawErrors, inputLabel = formData.options.inputLabel, placeholder = formData.placeholder;
    var styles = TextareaAutosizeInputStyles_1.default();
    var genericInputStyle = GenericInputStyles_1.default();
    var currentError = react_1.useMemo(function () { var _a; return ((_a = rawErrors) === null || _a === void 0 ? void 0 : _a.length) > 0 && rawErrors[0]; }, [rawErrors]);
    var handleTextareaChange = react_1.useCallback(function (e) {
        onChange(e.target.value);
    }, [value]);
    var checkout = usePlatformConfig_1.default().platformConfig.checkout;
    var showTradeInDisclaimer = (checkout || {}).showTradeInDisclaimer;
    return (<core_1.Box className={styles.container}>
      {inputLabel && (<core_1.Box display="flex">
          <core_1.Typography component="span" variant="subtitle1">
            <core_1.InputLabel htmlFor={id} required={required} className={genericInputStyle.label} data-test={"textareaAutosize_input:label:" + id}>
              {label}
            </core_1.InputLabel>
          </core_1.Typography>
        </core_1.Box>)}
      <core_1.TextareaAutosize data-test={"textareaAutosize_input:" + id} id={id} value={(value !== null && value !== void 0 ? value : '')} placeholder={placeholder} onChange={handleTextareaChange} className={styles.root}/>
      {currentError && (<core_1.Typography component="span" className={genericInputStyle.errorText} data-test={"textareaAutosize_input:error:" + id}>
          {currentError}
        </core_1.Typography>)}
      {showTradeInDisclaimer && (<core_1.Typography data-test={"text:tradeIn:disclaimer"} className={genericInputStyle.tradeinDisclaimer}>
          <Translation_1.default id="trans__checkout__enquiry_form__trade_in__disclaimer"/>
        </core_1.Typography>)}
    </core_1.Box>);
};
exports.default = TextareaAutosizeInput;
